import { cn } from "@/lib/utils";
import { BaseMessageCardContent, type BaseMessageCardProps } from "./index";

type SimpleMessageCardProps = BaseMessageCardProps;

export function SimpleMessageCard(props: SimpleMessageCardProps) {
  return (
    <div
      className={cn(
        "px-3 py-2 rounded-md border transition-colors min-w-0",
        props.className,
      )}
    >
      <BaseMessageCardContent {...props} className="" />
    </div>
  );
}
